var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { PeekBox, PeekTooltip, PeekIconButton, PeekTypography, } from "@piiqtechnologies/ui-components";
const ActionButton = (_a) => {
    var { Icon, iconSize = 12 } = _a, props = __rest(_a, ["Icon", "iconSize"]);
    return (React.createElement(PeekIconButton, Object.assign({ color: "info", size: "large", bordered: true, disabled: props.disabled }, props),
        React.createElement(PeekTypography, { fontSize: `${iconSize}px`, lineHeight: 0 },
            React.createElement(Icon, null))));
};
export const SpaceActionButton = (_a) => {
    var { tooltip } = _a, props = __rest(_a, ["tooltip"]);
    if (tooltip) {
        return (React.createElement(PeekTooltip, { title: React.createElement(React.Fragment, null, tooltip) },
            React.createElement(PeekBox, null,
                React.createElement(ActionButton, Object.assign({}, props)))));
    }
    return React.createElement(ActionButton, Object.assign({}, props));
};
export default SpaceActionButton;
